@if (showSpinner) {
  <app-loader> </app-loader>
}

<div class="new-login-wrapper">
  <div class="new-login-container">
    <div class="bacground-lines">
      <img src="../../../../assets/login/bg-lines.png" alt="">
    </div>

    <div class="login-header-section">
      <div class="header-logo-main">
        <div class="logo-bg-main">
          <img class="logo-bg" src="../../../../assets/login/logo-bg.png" alt="missing">
          <img class="logo" src="../../../../assets/login/new-logo.png" alt="missing">
        </div>
      </div>
      <div class="header-heading">
        <h1>Welcome To <span>Work Insights</span></h1>
        <p>Empowering Your Business with Seamless Workforce Management</p>
      </div>

    </div>
    <div class="login-body-section">
      <div class="login-cotent">
        <div class="login-body-imag-section">
          <div style="width: 80%; height: 500px;">
            <ng-lottie [options]="options"></ng-lottie>
          </div>
        </div>
        <div class="login-body-form-section">
          <div class="form-section">
            <div class="form-head">
              <img src="../../../../assets/login/new-logo.png" alt="Logo Missing">
            </div>
            <div class="form-body">

              <form *ngIf="step === 'credentials'" [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form-body-content">
                <div class="form-body-heading">
                  <h1>Login To your account </h1>
                  <p>Please enter your credentials to continue</p>
                </div>
                <div class="form-group">
                  <label for="email">Your Email</label>
                  <input type="text" formControlName="email" placeholder="Enter your email" [ngClass]="{
                    'is-invalid': loginForm.get('email')!.touched && loginForm.get('email')!.invalid,
                    'is-valid': loginForm.get('email')!.touched && loginForm.get('email')!.valid
                  }" />
                    @if (loginForm.get('email')!.touched && loginForm.get('email')!.invalid) {
                      <div>
                        @if (loginForm.get('email')!.hasError('required')) {
                          <small>Email is required.</small>
                        }
                        @if (loginForm.get('email')!.hasError('email')) {
                          <small>Invalid email format.</small>
                        }
                      </div>
                    }
                  </div>

                  <div class="form-group">
                    <label for="password">Password</label>
                    <div class="password-container">
                      <input [type]="passwordVisible ? 'text' : 'password'" formControlName="password"
                      placeholder="Enter password" [ngClass]="{
                        'is-invalid': loginForm.get('password')!.touched && loginForm.get('password')!.invalid,
                        'is-valid': loginForm.get('email')!.touched && loginForm.get('password')!.valid
                      }" />
                        <div class="eye-icon" (click)="togglePasswordVisibility()">
                          <img src="../../../../assets/login/eye.png" alt="toggle visibility" />
                        </div>

                      </div>
                      @if (loginForm.get('password')!.touched && loginForm.get('password')!.invalid) {
                        <div>
                          @if (loginForm.get('password')!.hasError('required')) {
                            <small>Password is required.</small>
                          }
                        </div>
                      }
                      <div class="form-group checkbox-field mt-2">
                        <input id="remeber_me" type="checkbox" />
                        <label>Remember Me</label>
                      </div>
                  </div>


                    <div class="submit-button">
                        <button type="submit" [disabled]="loginForm.invalid" class="btn login-btn rounded-pill">
                         Continue
                        </button>
                    </div>
                  </form>

                <!-- 2FA Setup Screen -->
                <div *ngIf="step === 'setup'" class="twofa-setup text-center">
                  <h4>Set up Two-Factor Authentication</h4>
                  <div class="qr-box my-2">
                    <img *ngIf="qrCodeDataUrl" [src]="qrCodeDataUrl" alt="2FA QR code" style="width:150px; max-width:420px; height:auto;"/>
                    <img *ngIf="!qrCodeDataUrl" src="../../../../assets/login/placeholder.svg" alt="2FA QR code" style="width:150px; max-width:420px; height:auto;"/>
                  </div>
                  <p class="mt-1 mb-1">Download the Google Authenticator app.</p>
                    <div class="app-buttons d-flex justify-content-center mb-3">
                      <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pli=1" target="_blank" class="app-store-link mr-2">
                        <img src="../../../../assets/login/Google-Play-Store-Button.png" alt="Google Play" />
                      </a>
                      <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank" class="app-store-link">
                        <img src="../../../../assets/login/Download_on_the_App_Store_Badge.png" alt="App Store" />
                      </a>
                    </div>
                  
                  <div class="submit-button">
                        <button class="btn login-btn rounded-pill" (click)="goToEnterCode()">
                          NEXT : ENTER CODE
                        </button>
                    </div>
                </div>

                <!-- 2FA Verify Screen -->
                <div *ngIf="step === 'verify'" class="twofa-verify text-center">
                  <h4>Enter Authentication Code</h4>
                  <p>Please enter the 6-digit code from your authenticator app.</p>
                  <div class="form-group d-flex justify-content-center">
                    <input inputmode="numeric" pattern="[0-9]*" type="text" [(ngModel)]="verificationCode" name="twofacode" class="twofa-input form-control" maxlength="8" placeholder="Enter code" />
                  </div>
                  <div class="submit-button mt-4">
                    <button class="btn login-btn rounded-pill" (click)="verifyCode()">Verify Code</button>
                  </div>
                </div>

                </div>
              </div>
            </div>
          </div>
          <div class="login-footer">
            <p>Streamline your employee tracking, attendance, and performance management with our advanced, user-friendly
            platform</p>
          </div>
        </div>

      </div>
    </div>